import { Component, Injector } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-link-type',
  templateUrl: './link-type.component.html',
  styleUrl: './link-type.component.scss'
})
export class LinkTypeComponent extends FieldType<FieldTypeConfig> {

  constructor (private injector: Injector) {
    super();
  }
  endpoint: string = '';
  linkLabel: string = '';

  ngOnInit(): void {
    this.endpoint = this.props['endpoint'];
    this.linkLabel = this.props['label']!;
  }

  onClick(): void {
    const service = this.injector.get(this.props['service']);
    service.openLink(this.endpoint, this.formControl?.value, this.linkLabel);
  }

  showLink(): boolean {
    const value = this.formControl?.value;
    return value !== null && value !== undefined && value !== '';
  }
}
